<template>
    <div>
        <pxkeji-rightHeader/>

        <div class="pxkeji-right-box">
            <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

            <a-form class="ant-advanced-search-form">
                <a-row :gutter="24">
                    <a-col :span="5">
                        <a-form-item label="付款时间">
                            <a-range-picker @change="onChangeWhere"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-item label="订单编号">
                            <a-input placeholder="请输入" v-model="where.keyword.orderId"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="3">
                        <a-form-item label="支付方式">
                          <a-select defaultValue="lucy" placeholder="请选择" :allowClear="true"
                                    v-model="where.keyword.paymentType"  @change="onTypeChange">
                            <a-select-option value="1">线上</a-select-option>
                            <a-select-option value="2">线下</a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                    <a-col :span="4">
                        <a-form-item label="支付类型">
                            <a-select defaultValue="lucy" placeholder="请选择" :allowClear="true"
                                      v-model="where.keyword.paymentMethod">
                                <a-select-option
                                        :value="info.value"
                                        v-for="(info, index) in paymentMethodList"
                                        :key="index"
                                >{{info.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="用户组">
                            <a-select
                                    show-search
                                    v-model="where.keyword.groupIds"
                                    :filter-option="filterOption"
                                    allowClear
                                    @change="groupChanged"
                            >
                                <a-select-option
                                        :value="info.id"
                                        v-for="(info, index) in grouplist"
                                        :key="index"
                                >{{info.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                </a-row>
                <a-row :gutter="24">
                    <a-col :span="5">
                        <a-form-item label="用户信息">
                          <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name"/>
                        </a-form-item>
                      </a-col>
                      <a-col :span="6">
                            <a-form-item label="主管部门">
                                <a-select
                                        show-search
                                        v-model="where.keyword.administration"
                                        :filter-option="filterOption"
                                        allowClear
                                        @change="administrationChanged"
                                >
                                    <a-select-option
                                            :value="info.itemName"
                                            v-for="(info, index) in administrationList"
                                            :key="index"
                                    >{{info.itemName}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="5">
                        <a-form-item label="单位名称">
                            <a-input placeholder="请输入单位名称" v-model="where.keyword.enterpriseName"/>
                        </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="所在地区">
                                <a-cascader
                                        :options="areas"
                                        placeholder="请选择所在地区"
                                        change-on-select
                                        @change="onAreachange"
                                        :default-value="areaList"
                                        :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                                />
                            </a-form-item>
                        </a-col>

                        <a-col :span="2" :style="{ textAlign: 'left' }">
                            <a-button type="primary" @click="searchList" v-btnlimit="'财务统计-搜索'">搜索</a-button>
                        </a-col>
                </a-row>
            </a-form>
        </div>

        <div class="pxkeji-right-box">
            <pxkeji-btn name="导出" class="pxkeji_basic_btn" @click="exportList" v-btnlimit="'财务统计-导出'"/>
            <div class="totalbox" style="float: right;">
                <div>
                    <span>本页合计金额：{{info.subtotal}}元 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 总订单数：{{info.totalCount}}个 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 总金额：{{info.totalPrice}}元</span>
                </div>
            </div>
            <a-table
                    :columns="list.columns"
                    rowKey="id"
                    :pagination="list.pagination"
                    @change="onChange"
                    :dataSource="list.datas"
                    :loading="isloading"
                    :locale="{emptyText:'暂无数据'}"
            >
        <span slot="totalMoney" slot-scope="totalMoney" >{{totalMoney.basicMoney+totalMoney.presentMoney}}</span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status.status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="type" slot-scope="type">
          <a-tag v-if="type=='wechatapp'" color="#01D10C">微信APP</a-tag>
          <a-tag v-else-if="type=='wechatqr'" color="#01D10C">微信扫码</a-tag>
          <a-tag v-else-if="type=='alipayapp'" color="#079DEA">支付宝APP</a-tag>
          <a-tag v-else-if="type=='alipayqr'" color="#079DEA">支付宝扫码</a-tag>
        </span>
        <span slot="source" slot-scope="source">
          <a-tag v-if="source=='order'" color="#f50">直接支付</a-tag>
          <a-tag v-else-if="source=='recharge'" color="#f50">余额支付</a-tag>
        </span>
                <span slot="action" slot-scope="info">
          <pxkeji-btn
                  name="学习明细"
                  size="small"
                  @click="showInfo(info.course_id,info.user_id)"
                  type="primary"
          />
          <a-divider type="vertical"/>
          <pxkeji-btn name="课程明细" size="small" @click="showCourse(info.user_id)" type="primary"/>
        </span>
            </a-table>
        </div>

        <a-modal
                :title="addedit.title"
                v-model="addedit.visible"
                width="60%"
                :footer="false"
                destroyOnClose
                :maskClosable="false"
        >
            <Info @callbackMethod="save" :id="addedit.id" :uid="addedit.uid"/>
        </a-modal>
        <a-modal
                :title="course.title"
                v-model="course.visible"
                width="60%"
                :footer="false"
                destroyOnClose
                :maskClosable="false"
        >
            <course @callbackMethod="save" :uid="course.uid"/>
        </a-modal>
    </div>
</template>
<script>
    var that;
    import Info from "./studyInfo.vue"; //学习明细
    import course from "./courseInfo.vue"; //课程明细
    const columns = [
        {
            dataIndex: "id",
            key: "id",
            align: "center",
            title: "订单编号"
        },
        {
            dataIndex: "userName",
            key: "userName",
            align: "center",
            title: "用户姓名"
        },
      /*  {
            dataIndex: "phone",
            key: "phone",
            align: "center",
            title: "手机号"
        },*/
        {
            dataIndex: "idCard",
            key: "idCard",
            align: "center",
            title: "身份证号"
        },
        {
            dataIndex: "email",
            key: "email",
            align: "center",
            title: "邮箱"
        },
        {
            dataIndex: "payprice",
            key: "payprice",
            align: "center",
            title: "支付金额"
        },
        {
            dataIndex: "totalprice",
            key: "totalprice",
            align: "center",
            title: "订单总金额"
        },
        {
            dataIndex: "paytime",
            key: "paytime",
            align: "center",
            title: "支付时间"
        },
        {
            dataIndex: "paymentMethod",
            key: "paymentMethod",
            align: "center",
            title: "支付类型"
        }

    ];

    export default {
        name: "userlist",
        data() {
            return {
                expand: false, //高级搜索
                areas:[],
                areaList: [],
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10 //页容
                    }
                },
                info: {
                    totalCount: 0,
                    todayCount: 0,
                    totalPrice: 0,
                    todayPrice: 0,
                    subtotal: 0
                },
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件
                        orderId: "",
                        name: "",
                        startTime: "",
                        endTime: "",
                        paymentMethod: "",
                        groupIds: "",
                        enterpriseName: "",
                        provience:"",
                        city:"",
                        area:"",
                        company:"",
                        // 2021 11 01 start
                        paymentType:"",
                        administration:"",
                        // 2021 11 01 end
                    }
                },
                selectRows: [], //选中项编号
                isloading: false,
                addedit: {
                    //编辑
                    visible: false,
                    id: 0,
                    title: "",
                    uid: 0
                },
                course: {
                    visible: false,
                    uid: 0
                },
                grouplist: [],
                // 2021 11 01 start
                onlineList:[
                    {
                      value:'wechatqr',
                      name:'微信扫码'
                    },
                    {
                      value:'wechatjs',
                      name:'微信支付'
                    },
                    {
                      value:'alipayqr',
                      name:'支付宝扫码'
                    },
                    {
                      value:'chinaums',
                      name:'银联商务'
                    },
                    {
                      value:'wechatapp',
                      name:'微信APP'
                    },
                     {
                      value:'alipayapp',
                      name:'支付宝APP'
                    },
                ],
                offlineList:[
                    {
                      value:'线下支付',
                      name:'线下支付'
                    },
                    {
                      value:'wallet',
                      name:'余额支付'
                    },
                ],
                paymentMethodList:[],
                administrationList:[],
                // 2021 11 01 end
                visibleSupply: false //弹框
            };
        },
        components: {
            Info: Info,
            course: course
        },
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.getarea();
                this.GetList();
                this.getgrouplist();
                this.getDictionaryItem(); //2021 11 01
            });
        },
        watch: {
            selectRows: function () {
                //console.log("watch", val);
            }
        },
        methods: {
            // 2021 11 01 start
              onTypeChange(v){
                if(v=='1'){
                  this.paymentMethodList=this.onlineList;
                }else{
                  this.paymentMethodList=this.offlineList;
                }
              },
               getDictionaryItem() {
                  this.$api.dictionaryItem.tree(23).then((res) => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                      this.administrationList = res.data;
                    } else {
                      this.error(res.errorMsg);
                    }
                  });

              },
              administrationChanged(v) {
                  this.where.keyword.administration = v;
              },
              // 2021 11 01 end
            toggle() {
                this.expand = !this.expand;
            },
            groupChanged(v) {
                this.where.keyword.groupIds = v;
            },
            onAreachange(v){
                // 2021 09 28 start
                if(v[0]){
                    this.where.keyword.provience=v[0];
                }else{
                    this.where.keyword.provience='';
                }
                if(v[1]){
                    this.where.keyword.city=v[1];
                }else{
                    this.where.keyword.city='';
                }
                if(v[2]){
                    this.where.keyword.area=v[2];
                }else{
                    this.where.keyword.area='';
                }
                // 2021 09 28 end
            },
            getgrouplist() {
                this.isloading = true;
                this.$api.usergroup
                    .getAll()
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.grouplist = res.data;
                        } else {
                            this.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                        this.error();
                    });
            },
              // 2021 10 22 start
            filterOption(input, option) {
             return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            },
            // 2021 10 22 end
            getarea(){
                this.areas=this.$api.city.city;
            },
            GetList() {
                //获取列表
                this.isloading = true;
                this.$api.order
                    .orderpageList(
                        this.list.pagination.current,
                        this.list.pagination.defaultPageSize,
                        this.where.keyword.orderId,
                        this.where.keyword.name,
                        this.where.keyword.paymentMethod,
                        3,
                        this.where.keyword.startTime,
                        this.where.keyword.endTime,
                        this.where.keyword.groupIds,
                        this.where.keyword.enterpriseName,
                        this.where.keyword.provience,
                        this.where.keyword.city,
                        this.where.keyword.area,
                        this.where.keyword.administration,
                    )
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {

                            this.list.datas = res.data.records;
                            this.list.pagination.total = Number(res.data.total);

                            this.info.subtotal = 0;
                            res.data.records.forEach(function (item, index) {
                                that.info.subtotal += item.payprice;
                            });
                            this.info.subtotal=Math.ceil(this.info.subtotal*100)/100;
                            this.info.totalCount = res.data.total;
                            this.info.totalPrice =
                                res.data.totalPrice == null ? 0 : res.data.totalPrice;
                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            onTimeChange(date, dateString) {
                this.where.keyword.startTime = dateString[0];
                this.where.keyword.endTime = dateString[1];
            },
            onChange(page) {
                //页面切换回调
                this.list.pagination.current = page.current;
                this.GetList();
            },
            onRowChange(selectedRowKeys) {
                //table 多选
                this.selectRows = selectedRowKeys;
            },
            clearRows() {
                //清空选中项
                this.selectRows = [];
            },
            searchList() {
                this.list.pagination.current = 1;
                this.GetList();
            },
            onChangeWhere(date, dateString) {
                this.where.keyword.startTime = dateString[0];
                this.where.keyword.endTime = dateString[1];
            },
            clear() {
                //清空搜索条件
                for (var info in this.where.keyword) {
                    this.where.keyword[info] = "";
                }
            },
            //日期选择
            timeonChange(date, dateString) {
                this.where.keyword.startDate = dateString[0];
                this.where.keyword.endDate = dateString[1];
            },
            //查看学习详情
            showInfo(id, uid) {
                this.addedit.visible = true;
                this.addedit.id = id;
                this.addedit.uid = uid;
            },
            //查看课程明细
            showCourse(uid) {
                this.course.visible = true;
                this.course.uid = uid;
            },
            delInfo(id) {
                this.$confirm({
                    title: "您确定要删除此项吗?",
                    okText: "确定",
                    okType: "danger",
                    cancelText: "我再想想",
                    onOk() {
                        that.isloading = true;
                        that.$api.member.customer
                            .removeById(id)
                            .then(res => {
                                that.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    that.$message.success(res.errorMsg);
                                    that.GetList();
                                } else {
                                    that.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                that.isloading = false;
                            });
                    },
                    onCancel() {
                    }
                });
            },
            /**导出 */
            exportList() {
                // console.log(this.$api.financeStatistics.exportPay())
                // return;
                window.location.href = this.$api.financeStatistics.exportPay(
                    this.where.keyword.startTime,
                    this.where.keyword.endTime,
                    this.where.keyword.name,
                    this.where.keyword.paymentMethod,
                    this.where.keyword.orderId, this.where.keyword.groupIds,
                    this.where.keyword.enterpriseName,
                    this.where.keyword.provience,
                    this.where.keyword.city,
                    this.where.keyword.area,
                    this.where.keyword.administration,
                );
            },
            //子组件传值
            save() {
                this.addedit.visible = false;
                this.GetList();
            },
            close() {
                this.$confirm({
                    title: "提示",
                    content: "您确定要禁用么",
                    okText: "确认",
                    cancelText: "取消"
                });
            },
            /**APP推送 */
            batchAppPush() {
                this.push.visible = true;
                this.push.ids = that.selectRows.join(",");
            }
        }
    };
</script>

<style>
    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    #components-form-demo-advanced-search .search-result-list {
        margin-top: 16px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #fafafa;
        min-height: 200px;
        text-align: center;
        padding-top: 80px;
    }

    .cang_sta {
        text-align: center;
    }

    .cang_sta img {
        width: 35px;
    }

    .totalbox span {
        margin-left: 20px;
        line-height: 32px;
        font-weight: bold;
    }
</style>

